import { frontendURL } from '../../../helper/URLHelper';
const PipelineView = () => import('./PipelineView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipeline'),
      name: 'pipeline_kanban',
      component: PipelineView,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
